import React, { useEffect, useState } from 'react';
import { YotpoBottomLine } from '../Types/Yotpo';
import { useTypedSelector } from '../Hooks/useTypedSelector';

const useYotpoBottomLine = (productId?: string) => {
  const [yotpoBottomLine, setYotpoBottomLine] = useState<
    YotpoBottomLine | undefined
  >();
  const [isPageVisible, setIsPageVisible] = useState(false);

  const { storeId } = useTypedSelector((state) => state.yotpo);

  useEffect(() => {
    const handleVisibilityChange = () => {
        setIsPageVisible(!document.hidden)
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    // Reload Yotpo widgets when switching product
    if (global.Yotpo && isPageVisible) {
      var yotpoApi = new global.Yotpo.API(global.yotpo);
      yotpoApi.refreshWidgets();
    }

    // Fetch Yotpo data from API
    if (productId) {
      getYotpoBottomLine(productId, storeId).then((data) =>
        setYotpoBottomLine(data)
      );
    }
  }, [productId]);

  return yotpoBottomLine;
};

const getYotpoBottomLine = async (
  productId: string,
  storeId: string
): Promise<YotpoBottomLine> => {
  const res = await fetch(
    `https://api-cdn.yotpo.com/v1/widget/${storeId}/products/${productId}/reviews.json`
  );
  return (await res.json()).response.bottomline;
};

export default useYotpoBottomLine;
